import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DeclarationInfoSection from './DeclarationInfoSection';
import DeclarationDataTable from './DeclarationDataTable';

const MainDeclarationTab = ({ declaration, isEditing, draft, onDraftChange, errorFields }) => {
  const { t } = useTranslation();

  return (
    <div className="main-declaration-tab">
      <DeclarationInfoSection declaration={declaration} title={t('features.ReportIncomeTax.show.main_form.title')} />
      <div className="declaration-table-wrapper">
        <DeclarationDataTable declaration={declaration} isEditing={isEditing} draft={draft} onDraftChange={onDraftChange} errorFields={errorFields} />
      </div>
    </div>
  );
};

MainDeclarationTab.propTypes = {
  declaration: PropTypes.shape({
    periodType: PropTypes.string,
    periodYear: PropTypes.number,
    periodMonth: PropTypes.number,
    periodQuarter: PropTypes.number,
    supplementaryNo: PropTypes.number,
    companyName: PropTypes.string,
    companyTaxCode: PropTypes.string,
    companyAddress: PropTypes.string,
    ct15HasMultiProvinceAlloc: PropTypes.bool,
    ct16TotalEmployees: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct17ResidentEmployees: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct18TotalWithTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct19ResidentWithTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct20NonResidentWithTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct21TotalTaxableIncome: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct22ResidentTaxableIncome: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct23NonResidentTaxableIncome: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct24InsurancePremium: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct25OilContractExemption: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct26TotalTaxableSubjectToWithholding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct27ResidentTaxableSubjectToWithholding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct28NonResidentTaxableSubjectToWithholding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct29TotalTaxWithheld: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct30ResidentTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct31NonResidentTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ct32InsuranceTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired,
  isEditing: PropTypes.bool,
  draft: PropTypes.shape({
    ct16TotalEmployees: PropTypes.string,
    ct17ResidentEmployees: PropTypes.string,
    ct19ResidentWithTax: PropTypes.string,
    ct20NonResidentWithTax: PropTypes.string,
    ct22ResidentTaxableIncome: PropTypes.string,
    ct23NonResidentTaxableIncome: PropTypes.string,
    ct24InsurancePremium: PropTypes.string,
    ct25OilContractExemption: PropTypes.string,
    ct27ResidentTaxableSubjectToWithholding: PropTypes.string,
    ct28NonResidentTaxableSubjectToWithholding: PropTypes.string,
    ct30ResidentTax: PropTypes.string,
    ct31NonResidentTax: PropTypes.string
  }),
  onDraftChange: PropTypes.func,
  errorFields: PropTypes.instanceOf(Set)
};

MainDeclarationTab.defaultProps = {
  isEditing: false,
  draft: null,
  onDraftChange: null,
  errorFields: null
};

export default MainDeclarationTab;
